// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Int from "../../../../node_modules/rescript/lib/es6/belt_Int.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Link$Showside from "./Link.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import MergedRef from "@react-hook/merged-ref";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as DynamicTruncate$Showside from "./DynamicTruncate.bs.js";
import * as EditorLayerItem$Showside from "./EditorLayerItem.bs.js";
import * as StylableElement$Showside from "./StylableElement.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
function getRatio(ratio) {
  if (typeof ratio !== "number") {
    return ratio._0 / ratio._1;
  }
  switch (ratio) {
    case /* Circle */0:
    case /* Square */1:
      return 1;
    case /* Landscape */2:
      return 4 / 3;
    case /* Portrait */3:
      return 2 / 3;
    case /* Panorama */4:
      return 21 / 9;
    case /* Wide */5:
      return 16 / 9;
    case /* Tall */6:
      return 9 / 16;
  }
}
function getColumns(columns) {
  switch (columns) {
    case /* OneColumnGrid */0:
      return 1;
    case /* TwoColumnGrid */1:
      return 2;
    case /* ThreeColumnGrid */2:
      return 3;
    case /* FourColumnGrid */3:
      return 4;
    case /* FiveColumnGrid */4:
      return 5;
    case /* SixColumnGrid */5:
      return 6;
    case /* SevenColumnGrid */6:
      return 7;
    case /* EightColumnGrid */7:
      return 8;
    case /* TwelveColumnGrid */8:
      return 12;
  }
}
function estimateCardSize(containerWidth, layout, productLayout, cardSize, cardShape, theme) {
  var columns = layout ? getColumns(productLayout) : Category$Showside.CardSize.getSlidesPerView(cardSize);
  var horizontalGap = Belt_Option.getWithDefault(Belt_Int.fromString(theme.columnGutter), 12);
  var width = containerWidth / columns - horizontalGap;
  var height = width / getRatio(cardShape);
  return [width | 0, height | 0];
}
function estimateSectionSize(containerWidth, layout, productLayout, cardSize, cardShape, count, theme) {
  var columns = layout ? getColumns(productLayout) : Category$Showside.CardSize.getSlidesPerView(cardSize);
  var rows = layout ? Math.ceil(count / columns) | 0 : 1;
  var match = estimateCardSize(containerWidth, layout, productLayout, cardSize, cardShape, theme);
  var height = Math.imul(match[1], rows);
  return [match[0], height];
}
var Size = {
  getRatio: getRatio,
  getColumns: getColumns,
  estimateCardSize: estimateCardSize,
  estimateSectionSize: estimateSectionSize
};
function getTextSizeCn(textSize) {
  switch (textSize) {
    case /* Xl */0:
      return "text-xl";
    case /* Lg */1:
      return "text-lg";
    case /* Base */2:
      return "text-base";
  }
}
function Card(Props) {
  var shapeOpt = Props.shape;
  var fluidOpt = Props.fluid;
  var id = Props.id;
  var nodeId = Props.nodeId;
  var link = Props.link;
  var preventLinkDefaultOpt = Props.preventLinkDefault;
  var lineClamp = Props.lineClamp;
  var titleTextSizeDesktopOpt = Props.titleTextSizeDesktop;
  var titleTextSizeMobileOpt = Props.titleTextSizeMobile;
  var showTitleOpt = Props.showTitle;
  var openLinkInNewTabOpt = Props.openLinkInNewTab;
  var selectedOpt = Props.selected;
  var inspectable = Props.inspectable;
  var roundedOpt = Props.rounded;
  var classNameOpt = Props.className;
  var title = Props.title;
  var contentBoxStylableClassName = Props.contentBoxStylableClassName;
  var titleStylableClassName = Props.titleStylableClassName;
  var imageSize = Props.imageSize;
  var fwdRef = Props.fwdRef;
  var dataTestId = Props.dataTestId;
  var dataCount = Props.dataCount;
  var titleDataTestId = Props.titleDataTestId;
  var renderTitle = Props.renderTitle;
  var childrenOpt = Props.children;
  var renderBeforeTitle = Props.renderBeforeTitle;
  var renderAfterTitle = Props.renderAfterTitle;
  var renderOverlay = Props.renderOverlay;
  var style = Props.style;
  var onClickDiv = Props.onClickDiv;
  var onClickLink = Props.onClickLink;
  var onHoverOpt = Props.onHover;
  var onMouseLeaveOpt = Props.onMouseLeave;
  var shape = shapeOpt !== undefined ? shapeOpt : /* Square */1;
  var fluid = fluidOpt !== undefined ? fluidOpt : false;
  var preventLinkDefault = preventLinkDefaultOpt !== undefined ? preventLinkDefaultOpt : false;
  var titleTextSizeDesktop = titleTextSizeDesktopOpt !== undefined ? titleTextSizeDesktopOpt : /* Xl */0;
  var titleTextSizeMobile = titleTextSizeMobileOpt !== undefined ? titleTextSizeMobileOpt : /* Lg */1;
  var showTitle = showTitleOpt !== undefined ? showTitleOpt : true;
  var openLinkInNewTab = openLinkInNewTabOpt !== undefined ? openLinkInNewTabOpt : false;
  var selected = selectedOpt !== undefined ? selectedOpt : false;
  var rounded = roundedOpt !== undefined ? roundedOpt : true;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var children = childrenOpt !== undefined ? Caml_option.valFromOption(childrenOpt) : null;
  var onHover = onHoverOpt !== undefined ? onHoverOpt : function (param) {};
  var onMouseLeave = onMouseLeaveOpt !== undefined ? onMouseLeaveOpt : function (param) {};
  var ref = React.useRef(null);
  var ref$1 = fwdRef !== undefined ? MergedRef(ref, fwdRef) : ref;
  var href;
  if (link !== undefined && link.TAG === /* URL */0) {
    var href$1 = link._0;
    href = href$1.trim() !== "" ? href$1 : undefined;
  } else {
    href = undefined;
  }
  var match = ViewportContext$Showside.use(undefined);
  var isMobile = match.isMobile;
  var tmp;
  if (typeof shape === "number") {
    switch (shape) {
      case /* Circle */0:
      case /* Square */1:
        tmp = "aspect-ratio-square";
        break;
      case /* Landscape */2:
        tmp = "aspect-ratio-4/3";
        break;
      case /* Portrait */3:
        tmp = "aspect-ratio-2/3";
        break;
      case /* Panorama */4:
        tmp = "aspect-ratio-21/9";
        break;
      case /* Wide */5:
        tmp = "aspect-ratio-16/9";
        break;
      case /* Tall */6:
        tmp = "aspect-ratio-9/16";
        break;
    }
  } else {
    tmp = "";
  }
  var aspectRatioCn = CSS$Showside.prefix(tmp);
  var aspectRatioCn$1 = fluid ? CSS$Showside.prefix("h-full") : aspectRatioCn;
  var aspectRatioStyle;
  if (typeof shape === "number") {
    aspectRatioStyle = undefined;
  } else {
    var h = shape._1;
    var w = shape._0;
    if (w === 0 && h === 0) {
      var w$1 = Belt_Option.getWithDefault(imageSize[0], 0);
      var h$1 = Belt_Option.getWithDefault(imageSize[1], 0);
      aspectRatioStyle = {
        paddingBottom: CSS$Showside.floatToPercentage(h$1 / w$1 * 100.0)
      };
    } else {
      aspectRatioStyle = fluid ? undefined : {
        paddingBottom: CSS$Showside.floatToPercentage(h / w * 100.0)
      };
    }
  }
  var roundedCn = shape === 0 ? CSS$Showside.prefix("rounded-full") : rounded ? CSS$Showside.prefix("rounded-custom") : "";
  var safariFixCn = CSS$Showside.prefix("clip-path-margin");
  var textAlignCn = shape === 0 ? "text-center" : "text-left";
  var pressedCn = CSS$Showside.prefix(isMobile ? "scale-100 active:scale-97 transition-transform duration-150" : "");
  var handleMouseOver = function (param) {
    Curry._1(onHover, undefined);
  };
  var defaultTitleRenderer = function (title) {
    var labelTextSize = isMobile ? getTextSizeCn(titleTextSizeMobile) : getTextSizeCn(titleTextSizeDesktop);
    var labelJustify = shape === 0 ? "justify-center" : "justify-start";
    var labelClassName = CSS$Showside.prefix(Cn.make(["pt-2 font-medium text-primary flex items-start space-x-2", labelTextSize, labelJustify]));
    var tmp = {
      lines: lineClamp,
      children: React.createElement(StylableElement$Showside.make, {
        className: titleStylableClassName,
        children: title
      })
    };
    if (titleDataTestId !== undefined) {
      tmp.dataTestId = Caml_option.valFromOption(titleDataTestId);
    }
    return React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["flex-grow-1 leading-normal relative", textAlignCn]))
    }, React.createElement("div", {
      className: labelClassName
    }, React.createElement(DynamicTruncate$Showside.make, tmp)));
  };
  var renderTitle$1 = function (param) {
    if (title !== undefined) {
      if (renderTitle !== undefined) {
        if (showTitle) {
          return Curry._1(renderTitle, defaultTitleRenderer(title));
        } else {
          return null;
        }
      } else if (showTitle) {
        return defaultTitleRenderer(title);
      } else {
        return null;
      }
    } else if (renderTitle !== undefined && showTitle) {
      return Curry._1(renderTitle, null);
    } else {
      return null;
    }
  };
  var cursor = href !== undefined || onClickDiv !== undefined || onClickLink !== undefined ? CSS$Showside.prefix("cursor-pointer") : CSS$Showside.prefix("cursor-default");
  var selectionBorder = selected ? React.createElement("div", {
    className: CSS$Showside.prefix("absolute -inset-1 border border-solid rounded-custom pointer-events-none border-accent")
  }) : null;
  var tmp$1 = {
    id: id,
    className: CSS$Showside.prefix(fluid ? "flex-grow" : ""),
    children: null
  };
  if (inspectable !== undefined) {
    tmp$1.kind = Caml_option.valFromOption(inspectable);
  }
  if (nodeId !== undefined) {
    tmp$1.nodeId = nodeId;
  }
  var tmp$2 = {
    className: Cn.make([CSS$Showside.prefix("w-full relative overflow-hidden flex-grow-0"), aspectRatioCn$1, roundedCn, pressedCn, safariFixCn])
  };
  if (aspectRatioStyle !== undefined) {
    tmp$2.style = Caml_option.valFromOption(aspectRatioStyle);
  }
  var content = React.createElement(EditorLayerItem$Showside.make, tmp$1, React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["relative", fluid ? "h-full" : ""])),
    id: id
  }, React.createElement("div", tmp$2, React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["absolute", "flex items-center justify-center", "w-full h-full"]))
  }, children), Belt_Option.mapWithDefault(renderOverlay, null, function (renderOverlay) {
    return Curry._1(renderOverlay, undefined);
  }))), React.createElement(StylableElement$Showside.make, {
    className: contentBoxStylableClassName,
    children: null
  }, Belt_Option.mapWithDefault(Belt_Option.flatMap(renderBeforeTitle, function (render) {
    return Curry._1(render, undefined);
  }), null, function (el) {
    return el;
  }), renderTitle$1(undefined), Belt_Option.mapWithDefault(Belt_Option.flatMap(renderAfterTitle, function (render) {
    return Curry._1(render, undefined);
  }), null, function (el) {
    return React.createElement("div", {
      className: CSS$Showside.prefix("mt-2")
    }, el);
  })));
  var children$1 = React.createElement(React.Fragment, undefined, content, selectionBorder);
  if (href !== undefined) {
    var tmp$3 = {
      children: children$1,
      href: href,
      fwdRef: ReactDOMUtils$Showside.Ref.domRef(ref$1),
      disabled: preventLinkDefault,
      unstyled: true,
      className: Cn.make([CSS$Showside.prefix("!flex !no-underline"), CSS$Showside.prefix("flex-col leading-0 group-2 relative no-touch-highlight"), fluid ? CSS$Showside.prefix("h-full") : "", cursor, className]),
      openLinkInNewTab: openLinkInNewTab,
      data: id,
      onMouseOver: handleMouseOver,
      onMouseLeave: onMouseLeave
    };
    if (style !== undefined) {
      tmp$3.style = Caml_option.valFromOption(style);
    }
    if (title !== undefined) {
      tmp$3.ariaLabel = Caml_option.valFromOption(title);
    }
    if (dataTestId !== undefined) {
      tmp$3.dataTestId = Caml_option.valFromOption(dataTestId);
    }
    if (dataCount !== undefined) {
      tmp$3.dataCount = dataCount;
    }
    if (onClickLink !== undefined) {
      tmp$3.onClick = Caml_option.valFromOption(onClickLink);
    }
    return React.createElement(Link$Showside.make, tmp$3);
  }
  var tmp$4 = {
    ref: ReactDOMUtils$Showside.Ref.domRef(ref$1),
    className: Cn.make([CSS$Showside.prefix("flex flex-col no-underline leading-0 group-2 relative no-touch-highlight"), fluid ? CSS$Showside.prefix("h-full") : "", cursor, className]),
    role: "link",
    tabIndex: 0,
    data: id,
    onMouseLeave: onMouseLeave,
    onMouseOver: handleMouseOver
  };
  if (title !== undefined) {
    tmp$4["aria-label"] = Caml_option.valFromOption(title);
  }
  if (style !== undefined) {
    tmp$4.style = Caml_option.valFromOption(style);
  }
  if (onClickDiv !== undefined) {
    tmp$4.onClick = Caml_option.valFromOption(onClickDiv);
  }
  var tmp$5 = {
    children: React.createElement("div", tmp$4, children$1)
  };
  if (dataTestId !== undefined) {
    tmp$5.dataTestId = Caml_option.valFromOption(dataTestId);
  }
  if (dataCount !== undefined) {
    tmp$5.dataCount = dataCount;
  }
  return React.createElement(DataAttribute$Showside.make, tmp$5);
}
Card.displayName = "Card";
var make = React.memo(Card);
export { Size, getTextSizeCn, make };
/* make Not a pure module */